import React, { lazy, Suspense, useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import SkeletonLoader from "./components/loader";
import { Route, Routes, useLocation } from "react-router-dom";
import ScrollTop from "./common/ScrollTop";
import Detail from "./pages/blogs/sections/blogs/detail";
const Footer = lazy(() => import("./components/footer/Footer"));
const Header = lazy(() => import("./components/header/Header"));
const Home = lazy(() => import("./pages/home/Home"));
const TechPgt = lazy(() => import("./pages/techPgt/TechPgt"));
const TechGenetics = lazy(() => import("./pages/techGenetics/TechGenetics"));
const About = lazy(() => import("./pages/about/About"));
const Contact = lazy(() => import("./pages/contact/Contact"));
// const BlogPage = lazy(() => import("./pages/blogs/BlogPage"));
// const FAQ = lazy(() => import("./pages/faq/FAQ"));
const Ethics = lazy(() => import("./pages/ethics/Ethics"));
const Privacy = lazy(() => import("./pages/privacy/Privacy"));
const Terms = lazy(() => import("./pages/terms/Terms"));

function App() {
  const [, setOverlay] = useState(false);

  useEffect(() => {
    AOS.init({
      once: false,
      offset: 100,
    });
  }, []);

  const location = useLocation();

  const lightHeader = ["/genetic-counseling", "/contact-us"].includes(
    location.pathname
  );

  return (
    <>
      <Header setOverlay={setOverlay} lightHeader={lightHeader} />
      <div className="main-content">
        <Suspense fallback={<SkeletonLoader />}>
          <ScrollTop />
          <Routes>
            <Route
              path="/"
              element={
                <Suspense fallback={<SkeletonLoader />}>
                  <Home />
                </Suspense>
              }
            />
            <Route
              path="/about-us"
              element={
                <Suspense fallback={<SkeletonLoader />}>
                  <About />
                </Suspense>
              }
            />
            <Route
              path="/contact-us"
              element={
                <Suspense fallback={<SkeletonLoader />}>
                  <Contact />
                </Suspense>
              }
            />
            <Route
              path="/our-technology"
              element={
                <Suspense fallback={<SkeletonLoader />}>
                  <TechPgt />
                </Suspense>
              }
            />
            <Route
              path="/genetic-counseling"
              element={
                <Suspense fallback={<SkeletonLoader />}>
                  <TechGenetics />
                </Suspense>
              }
            />
            {/* <Route
              path="/blogs"
              element={
                <Suspense fallback={<SkeletonLoader />}>
                  <BlogPage />
                </Suspense>
              }
            /> */}
            <Route
              path="/blog-detail/:id"
              element={
                <Suspense fallback={<SkeletonLoader />}>
                  <Detail />
                </Suspense>
              }
            />
            {/* <Route
              path="/faq"
              element={
                <Suspense fallback={<SkeletonLoader />}>
                  <FAQ />
                </Suspense>
              }
            /> */}
            <Route
              path="/ethics"
              element={
                <Suspense fallback={<SkeletonLoader />}>
                  <Ethics />
                </Suspense>
              }
            />
            <Route
              path="/privacy-policy"
              element={
                <Suspense fallback={<SkeletonLoader />}>
                  <Privacy />
                </Suspense>
              }
            />
            <Route
              path="/terms-conditions"
              element={
                <Suspense fallback={<SkeletonLoader />}>
                  <Terms />
                </Suspense>
              }
            />
          </Routes>
        </Suspense>
      </div>
      <Footer />
    </>
  );
}

export default App;
